/* GanaGana v3 — JS (checkout directo, sin modal) */
document.addEventListener('DOMContentLoaded', function () {

  /* ---------- COUNTDOWN PRINCIPAL ---------- */
  const timerEl = document.getElementById('gg-countdown-timer');
  if (timerEl) {
    const target = new Date(timerEl.dataset.target);
    function updateTimer() {
      const diff = target - new Date();
      if (diff <= 0) {
        timerEl.innerHTML = '<span class="gg-countdown__ended">' + (timerEl.dataset.endedText || '¡Sorteo finalizado!') + '</span>';
        return;
      }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000)  / 60000);
      const s = Math.floor((diff % 60000)    / 1000);
      const pad = n => String(n).padStart(2,'0');
      const set = (unit, val) => {
        const el = timerEl.querySelector(`[data-unit="${unit}"]`);
        if (el && el.textContent !== pad(val)) {
          el.textContent = pad(val);
          el.classList.add('pulse');
          setTimeout(() => el.classList.remove('pulse'), 600);
        }
      };
      set('days', d); set('hours', h); set('minutes', m); set('seconds', s);
    }
    updateTimer();
    setInterval(updateTimer, 1000);
  }

  /* ---------- ACORDEÓN LEGAL ---------- */
  document.querySelectorAll('.gg-legal__toggle').forEach(btn => {
    btn.addEventListener('click', function () {
      const item   = this.closest('.gg-legal__item');
      const isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.gg-legal__item.is-open').forEach(i => i.classList.remove('is-open'));
      if (!isOpen) item.classList.add('is-open');
    });
  });

  /* ---------- FADE UP ---------- */
  const fadeEls = document.querySelectorAll('.gg-fade-up');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) {
          setTimeout(() => e.target.classList.add('is-visible'), i * 70);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    fadeEls.forEach(el => io.observe(el));
  } else {
    fadeEls.forEach(el => el.classList.add('is-visible'));
  }

  /* ---------- MOBILE MENU TOPBAR ---------- */
  const hamburger  = document.querySelector('.gg-topbar__hamburger');
  const mobileMenu = document.querySelector('.gg-topbar__mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.toggle('is-open');
      hamburger.setAttribute('aria-expanded', mobileMenu.classList.contains('is-open'));
    });
  }

  /* ---------- SMOOTH SCROLL para links de sección ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', function (e) {
      const id = this.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (target) {
        e.preventDefault();
        const offset = 70;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
        if (mobileMenu) mobileMenu.classList.remove('is-open');
      }
    });
  });

});
